<template>
  <v-card class="kim-card outlined ">
    <v-card-title>
      <div class="body-1">Historial de cambios</div>
      <v-spacer></v-spacer>
      <v-btn-toggle color="primary" dense v-model="filter" >
        <v-btn x-small value="all">Todas</v-btn>
        <v-btn x-small value="attach">Solo agregadas</v-btn>
        <v-btn x-small value="detach">Solo eliminadas</v-btn>
      </v-btn-toggle>
    </v-card-title>
    <v-card-text class="py-0 px-0">
      <v-timeline
              align-top
              dense
          >
            <v-timeline-item
                v-for="(item, i) in filteredHistory"
                :key="i"
                :icon="item.action === 'attach' ? 'mdi-plus' : 'mdi-minus' "
                :color="item.action === 'attach' ? 'success' : 'error'"
                small
            >
              <v-row class="pt-1" no-gutters>
                <v-col cols="12" md="3" xl="2" class="text-left">
                  <v-chip outlined small :color="item.label.color">
                    <div class="text-truncate">{{item.label.description}}</div>
                  </v-chip>
                  <div class="ml-2 mt-1 text-caption text-truncate">{{$moment(item.created_at).format('DD/MM/YYYY HH:mm')}}hrs.</div>
                </v-col>
                <v-col class="pl-2 text-left">
                  <strong class="text-truncate">{{item.action === 'attach' ? 'Agregada' : 'Eliminada'}}</strong>
                  <div class="text-caption text-truncate">
                    por {{item.synced_by.first_name}} {{item.synced_by.last_name}}
                  </div>
                </v-col>
              </v-row>
            </v-timeline-item>
      </v-timeline>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "LabelHistory",
  props:{
    history: {
      type: Array,
      default: () => []
    }
  },
  data(){
    return {
      filter: 'attach'
    }
  },
  computed:{
    filteredHistory(){
      const vm = this
      if(vm.filter === 'all') return vm.history

      return vm.history.filter(item => item.action === vm.filter)

    }
  }
}
</script>

<style scoped>

</style>
